module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image21.e65422f2.jpg";